<div class="wre-table-container">
  <div #tableContainer class="table-responsive">
    <table class="table wre-table fixed-column">
      <thead>
        <tr>
          <th class="sticky-column column-name fixed-column">Role Name</th>
          @for (permission of permissions$ | async; track permission; let colIdx = $index) {
            <th
              class="column-permission text-center"
              [class.highlighted]="colIdx === hoveredColumn"
              (mouseenter)="setHovered(colIdx, null)"
              (mouseleave)="resetHovered()">
              {{ permission.name }}
            </th>
          }
        </tr>
      </thead>
      <tbody class="border-bottom">
        @for (role of roles$ | async; track role; let rowIdx = $index) {
          <tr>
            <td
              class="sticky-column column-name fixed-column"
              wreToolkitTitleWhenTruncated
              ngbTooltip
              container="body"
              [class.highlighted]="rowIdx === hoveredRow"
              (mouseenter)="setHovered(null, rowIdx)"
              (mouseleave)="resetHovered()">
              <ngb-highlight [result]="role.name" [term]="rolesService.searchTerm"></ngb-highlight>
            </td>
            @for (permission of permissions$ | async; track permission; let colIdx = $index) {
              <td
                (mouseenter)="setHovered(colIdx, rowIdx)"
                (mouseleave)="resetHovered()"
                class="column-permission text-center"
                [class.highlighted]="colIdx === hoveredColumn || rowIdx === hoveredRow"
                [class.main-highlighted]="colIdx === hoveredColumn && rowIdx === hoveredRow">
                @if (checkRolePermission(role, permission)) {
                  <i class="fa fa-check" aria-hidden="true"></i>
                } @else {
                  <i #timesBlock class="fa fa-times" aria-hidden="true"></i>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
